import { useRouteMatch } from 'react-router-dom';

import { useHelpArea } from '@/core/domain/helpcenter/HelpAreas/HelpAreas.hooks';

import HelpCenterBanner from '@/components/HelpCenter/HelpCenterBanner';

import './styles.less';
import HelpCenterWorksheets from '@/components/HelpCenter/HelpCenterWorksheets';
import HelpCenterItemsContent from '@/components/HelpCenter/HelpCenterItemsContent';
import { Breadcrumb, Col, Row } from 'antd';
import HelpItemAside from '@/components/HelpCenterLayout/HelpItemAside';

function HelpCenterHelpAreaPage() {
  const { helpAreaId } = useRouteMatch<{ helpAreaId: string }>().params;

  const { data, isFetching } = useHelpArea(Number(helpAreaId));

  return (
    <div style={{ padding: '0px 24px' }}>
      <Row gutter={[24, 24]}>
        <Col span={24} md={24} lg={5}>
          <HelpItemAside />
        </Col>

        <Col
          span={24}
          md={24}
          lg={19}
          style={{ paddingTop: 24, paddingBottom: 24 }}
        >
          <div style={{ marginBottom: 24 }}>
            <Breadcrumb>
              <Breadcrumb.Item>
                <a href="/helpCenter">Home</a>
              </Breadcrumb.Item>

              {data?.parent?.parentId && (
                <Breadcrumb.Item>
                  <a href={`/helpCenter/${data?.parent.parentId}`}>
                    {data?.parent.parentName}
                  </a>
                </Breadcrumb.Item>
              )}

              <Breadcrumb.Item>{data?.name}</Breadcrumb.Item>
            </Breadcrumb>
          </div>

          <div style={{ marginBottom: 24 }}>
            <HelpCenterBanner
              title={data?.name}
              loading={isFetching}
              helpArea={data}
            />
          </div>

          {data?.name === 'Planilhas' ? (
            <HelpCenterWorksheets loading={isFetching} items={data.items} />
          ) : (
            <HelpCenterItemsContent loading={isFetching} items={data?.items} />
          )}
        </Col>
      </Row>
    </div>
  );
}

export default HelpCenterHelpAreaPage;
